export const generateTimes = config => {
	return config.times
}
